import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSiren: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="siren, alarm"><path d="M4.75 16.75V21.25H19.25V16.75H4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 16.75V12C6.75 9.10051 9.10051 6.75 12 6.75C14.8995 6.75 17.25 9.10051 17.25 12V16.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 1.75V2.775M21.225 12H22.25M2.775 12H1.75M18.5231 5.47694L19.2478 4.75216M5.47696 5.47692L4.75218 4.75213" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 16.75V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSiren;
